// we are saving file upload references in userToFileUploadMappings
// in the following format
// { [referenceId]:['file_id_1', 'file_id_2', ...]}

const FileUploads = {
  name: 'fileUploads',
  state: {
    userToFileUploadMappings: {},
  },

  reducers: {
    addFileReferences(state, payload) {
      const { referenceId, filesIds } = payload;
      const previousFileIds = state.userToFileUploadMappings[referenceId] || [];
      const newFileIds = filesIds.filter(item => !previousFileIds.includes(item));
      const userToFileUploadMapping = { [referenceId]: [...previousFileIds, ...newFileIds] };
      return {
        ...state,
        userToFileUploadMappings: { ...state.userToFileUploadMappings, ...userToFileUploadMapping },
      };
    },
    resetMappings(state) {
      return { ...state, userToFileUploadMappings: {} };
    },
  },
};

export default FileUploads;
